import './post.scss'

import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '../global'
import { authorClasses, logos } from '../../utils'

const SocialLink = ({ social, logo: { logo, alt }, role }) => {
  if (!social) return null

  return (
    <Link
      to={social}
      target="_blank"
      className={authorClasses('social-link', role)}
    >
      <img alt={alt} src={logo} />
    </Link>
  )
}

const AuthorSocials = ({ socialLinks, role = '' }) => {
  if (!socialLinks) return null

  const { facebook, instagram, twitter, linkedin } = socialLinks

  return (
    <div className="author-socials">
      <SocialLink social={facebook} logo={logos.facebook} role={role} />
      <SocialLink social={instagram} logo={logos.instagram} role={role} />
      <SocialLink social={twitter} logo={logos.twitter} role={role} />
      <SocialLink social={linkedin} logo={logos.linkedin} role={role} />
    </div>
  )
}

SocialLink.propTypes = {
  social: PropTypes.string,
  logo: PropTypes.shape({
    logo: PropTypes.string,
    alt: PropTypes.string,
  }),
  role: PropTypes.string,
}

AuthorSocials.propTypes = {
  socialLinks: PropTypes.shape({
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    twitter: PropTypes.string,
    linkedin: PropTypes.string,
  }),
  role: PropTypes.string,
}

export default AuthorSocials
